import React from 'react';
import PropTypes from 'prop-types';
const _ = {
    values: require('lodash/values')
};

import { Row } from 'react-bootstrap';

const propTypes = {
    id: PropTypes.string,
    projects: PropTypes.object.isRequired, // keyed by project id
    activities: PropTypes.array.isRequired,
    selectedActivities: PropTypes.array.isRequired,
    templates: PropTypes.object, // keyed by template id
    chooseHandler: PropTypes.func.isRequired,
    chooseButtonText: PropTypes.string.isRequired,
    secondButtonText: PropTypes.string,
    secondButtonHandler: PropTypes.func,
    thirdButtonText: PropTypes.string,
    thirdButtonHandler: PropTypes.func,
    thirdButtonDisabled: PropTypes.bool,
};

const defaultProps = {
    id: 'activity-chooser',
    projects: {},
    activities: {},
    templates: {},
};

class ShortCourseActivityChooser extends React.Component {
    constructor(props) {
        super(props);
        
        let selectedProject = "-1";
        let selectedActivity = "-1";
        
        const project_ids = Object.keys(props.projects);
        if (project_ids.length === 1) {
            selectedProject = project_ids[0];
        }
        
        this.state = {
            selectedProject,
            selectedActivity
        };
    }

    chooseHandler=(e)=>{
        e.preventDefault;
        this.props.chooseHandler(parseInt(this.state.selectedActivity, 10));
        return false;
    }

    secondButtonHandler=(e)=>{
        e.preventDefault;
        this.props.secondButtonHandler(parseInt(this.state.selectedActivity, 10));
        return false;
    }

    thirdButtonHandler=(e)=>{
        e.preventDefault;
        this.props.thirdButtonHandler(parseInt(this.state.selectedActivity, 10));
        return false;
    }

    setStateProject=(e)=>{
        this.setState({ selectedProject: e.target.value, selectedActivity: "-1" })
    }

    setStateActivity=(e)=>{
        this.setState({ selectedActivity: e.target.value })
    }

    render() {
        return (
            <div id={this.props.id} className="sc-activity-chooser">
                <div className="selectors">
                    <select value={this.state.selectedProject} onChange={this.setStateProject}>
                        <option value="-1" disabled hidden>Select project</option>
                        {Object.keys(this.props.projects).map((projectId) =>
                            <option key={`p-${projectId}`} value={projectId}>{this.props.projects[projectId].name}</option>
                        )}
                    </select>
                    {(this.state.selectedProject) !== "-1" &&
                        <select value={this.state.selectedActivity} onChange={this.setStateActivity}>
                            <option value="-1" disabled hidden>Select activity</option>
                            {_.values(this.props.activities).filter(a => a.project_id === parseInt(this.state.selectedProject, 10)).map((activity) => {
                                let tmpl = this.props.templates[activity.template_id];
                                return (
                                    <option 
                                        key={`a${activity.id}`} 
                                        value={activity.id} 
                                        disabled={(this.props.selectedActivities.indexOf(activity) >= 0)}>
                                        {activity.title} ({tmpl ? tmpl.name : '...'})
                                    </option>
                                )
                            })}
                        </select>
                    }
                </div>
                <div className="button-div">
                    <button className="btn btn-alt"
                        disabled={this.state.selectedProject === "-1" || this.state.selectedActivity === "-1"}
                        onClick={this.chooseHandler}>
                            {this.props.chooseButtonText}
                    </button>
                    { (this.props.secondButtonText && this.props.secondButtonHandler) ? 
                    <button className="btn btn-alt"
                        disabled={this.state.selectedProject === "-1" || this.state.selectedActivity === "-1"}
                        onClick={this.secondButtonHandler}>
                            {this.props.secondButtonText}
                    </button>
                    : null }
                    { (this.props.thirdButtonText && this.props.thirdButtonHandler) ? 
                    <button className="btn btn-alt"
                        disabled={this.props.thirdButtonDisabled || this.state.selectedProject === "-1" || this.state.selectedActivity === "-1"}
                        onClick={this.thirdButtonHandler}>
                            {this.props.thirdButtonText}
                    </button>
                    : null }
                </div>
            </div>
        );
    }
}

ShortCourseActivityChooser.propTypes = propTypes;
ShortCourseActivityChooser.defaultProps = defaultProps;

export default ShortCourseActivityChooser;